import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/erpSalesOrder/initialState.erpSalesOrder.data';
import {
  fetchOrderItems as fetchOrderItemsAPI,
  erpSalesOrderLineItemsSave as erpSalesOrderLineItemsSaveAPI,
  updateErpSalesOrderLineItems as updateErpSalesOrderLineItemsAPI,
  deleteErpSalesOrderItems as deleteErpSalesOrderItemsAPI,
  fetchOrderlineItem as fetchOrderlineItemAPI,
  productNameSearch as productNameSearchAPI,
  productSearch as productSearchAPI,
} from '../../../apis/erpSalesOrderAPI';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import {
  ACTIONS_ERP_PRODUCT,
  ACTIONS_ERP_SALES_ORDER_ITEMS,
} from '../../../constants/actionCreator';
import {
  CHECK_BOX_VALUE,
  handlePending,
  handleRejection,
} from '../../../constants';
import { formatGlobalDate } from '../../../utils/common';

//API Calls
export const fetchOrderItems = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.ITEMS_TAB.GET_ORDER_ITEMS,
  fetchOrderItemsAPI
);
export const productSearch = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.SEARCH_ALL_PRODUCT,
  productSearchAPI
);
export const erpSalesOrderLineItemsSave = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.ITEMS_TAB.SAVE_ERP_LINE_ITEM,
  erpSalesOrderLineItemsSaveAPI
);

export const updateErpSalesOrderLineItems = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.ITEMS_TAB.UPDATE_ERP_LINE_ITEM,
  updateErpSalesOrderLineItemsAPI
);

export const deleteErpSalesOrderItems = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.ITEMS_TAB.DELETE_ERP_LINE_ITEM,
  deleteErpSalesOrderItemsAPI
);

export const fetchOrderlineItem = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.ITEMS_TAB.GET_ORDER_LINE_ITEM,
  fetchOrderlineItemAPI
);

export const productNameSearch = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.SEARCH_PRODUCT_NAME,
  productNameSearchAPI
);

const ErpSalesOrderSlice = createSlice({
  name: 'erpSalesOrder',
  initialState,
  reducers: {
    setErpSearch: (state, action) => {
      state[action.payload.key] = action?.payload?.value;
    },
    setErpManualOrder: (state, action) => {
      if (state.manualPurchaseOrder === null) {
        state.manualPurchaseOrder = {};
      }
      if (state.manualPurchaseOrder?.orderNumber) {
        state.manualPurchaseOrder[action.payload.key] = action?.payload?.value;
      }
      if (state.erpFastSearchData?.salesOrders?.length) {
        state.erpFastSearchData.salesOrders[0].comment = action?.payload?.value;
      }
      if (state.erpOrderSearchData?.salesOrders?.length) {
        state.erpOrderSearchData.salesOrders[0].comment =
          action?.payload?.value;
      }
    },
    setManualPurchaseOrder: (state, action) => {
      state.manualPurchaseOrder =
        action?.payload || initialState.manualPurchaseOrder;
    },
    setErpStatingSearch: (state, action) => {
      state.erpStagingSearchData = action?.payload;
    },
    setErpFastSearch: (state, action) => {
      state.erpFastSearchData = action?.payload;
    },
    setErpFastSearchItems: (state, action) => {
      state.erpFastSearchItemsData = action?.payload;
    },
    setDisplayType: (state, action) => {
      state.displayType = action?.payload;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action?.payload;
    },
    setEntitlementSummary: (state, action) => {
      state.entitlmentSummaryData = action?.payload ? action?.payload : [];
      state.entitlementSummaryTotal = action?.payload
        ? action?.payload?.totalRecords
        : 0;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action?.payload;
    },
    setAddLineItemClicked: (state, action) => {
      state.addLineItemClicked = action?.payload || false;
    },
    setCreatedMPOSuccessfully: (state, action) => {
      state.createdMPOSuccessfully = action?.payload || false;
    },
    resetValues: (state) => {
      state.orderNumberFrom = initialState.orderNumberFrom;
      state.orderNumberTo = initialState.orderNumberTo;
      state.importType = initialState.importType;
      state.orderType = initialState.orderType;
      state.orderNumberSearch = initialState.orderNumberSearch;
      state.searchLoading = initialState.searchLoading;
      state.searchResult = initialState.searchResult;
      state.erpStagingSearchData = initialState.erpStagingSearchData;
      state.selectedOrder = initialState.selectedOrder;
      state.displayType = initialState.displayType;
      state.entitlmentSummaryData = [];
      state.entitlementSummaryTotal = 0;
      state.doNotResetFlag = initialState.doNotResetFlag;
    },
    resetOrderItems: (state) => {
      state.salesOrderItems = initialState.salesOrderItems;
      state.entitlmentSummaryData = initialState.entitlmentSummaryData;
    },
    handleAddItemModal: (state, action) => {
      state.isAddItemLine = action?.payload;
      state.isErpLineUpdate = false;
      state.selectedSalesProductData = initialState.selectedSalesProductData;
      state.erpLineItem.shipQuantity = initialState.erpLineItem.shipQuantity;
      state.erpLineItemPrice = initialState.erpLineItemPrice;
    },
    handleProductModal: (state, action) => {
      state.isSalesProductModal = action?.payload;
      state.searchProductData = [];
      state.salesProduct = initialState.salesProduct;
    },
    handleResetSearch: (state) => {
      state.salesProduct = initialState.salesProduct;
      state.searchProductData = [];
      state.searchProductotalRecord = 0;
      state.isSearchProductResults = initialState.isSearchProductResults;
    },
    handleProductSearchForm: (state, action) => {
      state.salesProduct[action.payload.name] = action?.payload?.value;
    },
    selectedProductData: (state, action) => {
      state.selectedSalesProductData = action?.payload
        ? action?.payload[0]
        : [];
      const checkItems = () => {
        if (state.salesOrderItems?.length === 0) {
          return false;
        } else {
          return state.salesOrderItems?.some((orderItems) => {
            return state.isErpLineUpdate
              ? (state.editsalesProductCode?.trim() === ''
                  ? state.selectedSalesProductData?.productCode?.trim()
                  : state.editsalesProductCode?.trim()) &&
                  orderItems?.lineNumber !==
                    state.selectedErpLineItemGridData?.lineNumber &&
                  formatGlobalDate(orderItems?.shipDate) ===
                    formatGlobalDate(state.shipDate)
              : orderItems?.salesProductCode?.trim() ===
                  state.selectedSalesProductData?.productCode?.trim() &&
                  formatGlobalDate(orderItems?.shipDate) ===
                    formatGlobalDate(state.shipDate);
          });
        }
      };

      const isDuplicate = checkItems();
      if (!isDuplicate) {
        state.salesProductName = '';
        state.salesProductName =
          action?.payload?.length === 1
            ? state.selectedSalesProductData?.name
            : state.selectedErpLineItemGridData?.salesProductCode;
        state.isSalesProductModal = false;
        state.editsalesProductId = state.selectedSalesProductData?.id;
        state.editsalesProductCode =
          state.selectedSalesProductData?.productCode;
      } else {
        state.isSalesProductModal = true;
        state.alertDialog = true;
        //Clear Selected Product Data
        state.selectedSalesProductData = null;
        state.editsalesProductId = 0;
        state.editsalesProductCode = '';
        state.isDisabledButtons = true;
        state.salesProductName = '';
      }
    },
    clearSelectedProductData: (state) => {
      state.selectedSalesProductData = null;
      state.editsalesProductId = 0;
      state.editsalesProductCode = '';
      state.isDisabledButtons = true;
      state.salesProductName = '';
    },
    handleErpLineItemForm: (state, action) => {
      state.erpLineItem[action.payload.name] = action?.payload?.value || '';
    },
    handleSlelcetederpLineItem: (state, action) => {
      state.selectedErpLineItemGridData = action?.payload;
      state.erpLineItemPrice.unitPrice = action?.payload?.unitPrice || '';
      state.erpLineItemPrice.salesPrice = action?.payload?.salesPrice || '';
      state.erpLineItemPrice.unsupportedFlag =
        action?.payload?.unsupportedFlag?.toLowerCase() === CHECK_BOX_VALUE.yes
          ? CHECK_BOX_VALUE.yes
          : CHECK_BOX_VALUE.no;
      state.salesProductValue = action?.payload?.salesProductCode;
      state.isAddItemLine = true;
      state.isErpLineUpdate = true;
      state.isDeleteLineItem = false;
    },
    handleUpdateErpItemsdata: (state) => {
      if (state.isErpLineUpdate) {
        state.erpLineItem.shipQuantity =
          state.selectedErpLineItemGridData?.quantity;
      } else {
        state.erpLineItem.shipQuantity = null;
      }

      state.salesProductId = state.selectedErpLineItemGridData?.salesProductId;
    },
    handleErpLinePriceForm: (state, action) => {
      state.erpLineItemPrice[action.payload.name] = action?.payload?.value;
    },
    handleDeleteApiResponse: (state, action) => {
      state.isDeleteLineItem = action?.payload;
    },
    handleSaveApiResponse: (state, action) => {
      state.issaveLineItem = action?.payload;
    },
    handleErrorAlert: (state, action) => {
      state.alertDialog = action?.payload;
    },
    handleLineNumberSwitch: (state, action) => {
      state.selectedErpLineItemGridData = action?.payload;
      state.isLineNumbarClick = true;
    },
    handleProductCodeSwitch: (state, action) => {
      state.selectedErpLineItemGridData = action?.payload;
      state.isLineNumbarClick = true;
    },
    handleProductNameSearchFound: (state, action) => {
      state.salesProductNameFound = action?.payload;
      state.salesProductValue = state?.salesProductName;
    },
    handleIsDisabled: (state, action) => {
      state.isDisabledButtons = action?.payload;
    },
    setBackUrl: (state, action) => {
      state.backUrl = action?.payload ? action?.payload : initialState.backUrl;
    },
    handleisErpLineUpdate: (state, action) => {
      state.isErpLineUpdate = action?.payload;
    },
    resetMultipleInputs: (state) => {
      state.orderNumberFrom = initialState.orderNumberFrom;
      state.orderNumberTo = initialState.orderNumberTo;
      state.importType = initialState.importType;
      state.orderType = initialState.orderType;
      state.searchLoading = initialState.searchLoading;
      state.searchResult = initialState.searchResult;
      state.erpStagingSearchData = initialState.erpStagingSearchData;
      state.selectedOrder = initialState.selectedOrder;
      state.displayType = initialState.displayType;
      state.entitlmentSummaryData = [];
      state.entitlementSummaryTotal = 0;
    },
    setdoNotResetFlag: (state, action) => {
      state.doNotResetFlag = action?.payload;
    },
    setShipDate: (state, action) => {
      if (action?.payload === null) {
        state.shipDate = null;
        state.oldshipDate = null;
        state.newshipDate = null;
      } else {
        state.shipDate = action?.payload;
        state.oldshipDate =
          state.oldshipDate === null ? action?.payload : state.oldshipDate;
        state.newshipDate = action?.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderItems.pending, (state, action) => {
        handlePending(state, action);
        state.isOrderItemDataFound = null;
        state.salesOrderItemsTotal = 0;
        state.salesOrderItems = [];
      })
      .addCase(fetchOrderItems.fulfilled, (state, action) => {
        state.loading = false;
        state.salesOrderItems = [];
        state.salesOrderItems = action?.payload
          ? action?.payload?.salesOrderItems?.sort(
              (a, b) => new Date(b.shipDate) - new Date(a.shipDate)
            )
          : [];
        state.isOrderItemDataFound =
          action?.payload?.salesOrderItems?.length > 0;
        state.salesOrderItemsTotal = action?.payload?.totalRecords || 0;
        state.isUpdateLineItem = '';
      })
      .addCase(fetchOrderItems.rejected, (state, action) => {
        handleRejection(state, action);
        state.isOrderItemDataFound = true;
        state.salesOrderItemsTotal = 0;
        state.salesOrderItems = [];
      })

      .addCase(productSearch.pending, (state) => {
        state.searchProductData = [];
        state.isSearchProductResults = null;
      })
      .addCase(productSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.searchProductData = action?.payload ? action?.payload : [];
        state.searchProductotalRecord = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.isSearchProductResults = action?.payload?.length > 0;
      })
      .addCase(productSearch.rejected, (state, action) => {
        handleRejection(state, action);
        state.searchProductData = [];
        state.searchProductotalRecord = 0;
        state.isSearchProductResults = true;
      })

      .addCase(productNameSearch.pending, (state, action) => {
        handlePending(state, action);
        state.salesProductName = '';
      })
      .addCase(productNameSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.salesProductName = action?.payload?.name || '';
        state.editsalesProductId = action?.payload?.id || '';
        state.editsalesProductCode = action?.payload?.productCode || '';
        state.salesProductNameFound = true;
      })
      .addCase(productNameSearch.rejected, (state, action) => {
        handleRejection(state, action);
        state.salesProductName = '';
      })

      .addCase(erpSalesOrderLineItemsSave.pending, handlePending)
      .addCase(erpSalesOrderLineItemsSave.fulfilled, (state, action) => {
        state.loading = false;
        state.saveOrderLineItem = action?.payload || [];
        if (action?.payload) {
          state.salesOrderItems.push(action?.payload);
          //Updating Selected Item Data with Added Item after Save
          if (state.isUpdateLineItem == '') {
            state.selectedErpLineItemGridData = {
              orderItemId: action?.payload?.orderItemId || '',
            };
          }

          state.erpLineItemPrice.unitPrice = action?.meta?.arg?.unitPrice
            ? parseFloat(action?.meta?.arg?.unitPrice).toFixed(2)
            : '';
          state.erpLineItemPrice.salesPrice = action?.meta?.arg?.salesPrice
            ? parseFloat(action?.meta?.arg?.salesPrice).toFixed(2)
            : '';
          state.erpLineItemPrice.unsupportedFlag =
            action?.meta?.arg?.unsupportedFlag?.toLowerCase() ===
            CHECK_BOX_VALUE.yes
              ? CHECK_BOX_VALUE.yes
              : CHECK_BOX_VALUE.no;
          state.salesProductValue = action?.meta?.arg?.productCode;
          state.erpLineItem.shipQuantity = action?.meta?.arg?.shipQuantity;
        }
        state.issaveLineItem = true;
      })
      .addCase(erpSalesOrderLineItemsSave.rejected, handleRejection)

      .addCase(updateErpSalesOrderLineItems.pending, handlePending)
      .addCase(updateErpSalesOrderLineItems.fulfilled, (state, action) => {
        state.loading = false;
        state.updateErpLineItem = action?.payload;
        state.updateErpLineItem.unsupportedFlag =
          action?.payload?.unsupportedFlag?.toLowerCase() ===
          CHECK_BOX_VALUE.yes
            ? CHECK_BOX_VALUE.yes
            : CHECK_BOX_VALUE.no;
        state.isUpdateLineItem = true;
        if (state.isUpdateLineItem == '') {
          state.selectedErpLineItemGridData = {
            orderItemId: action?.payload?.orderItemId || '',
          };
        }
      })
      .addCase(updateErpSalesOrderLineItems.rejected, handleRejection)

      .addCase(deleteErpSalesOrderItems.pending, handlePending)
      .addCase(deleteErpSalesOrderItems.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteErpLineItem = action?.payload;
        state.isDeleteLineItem = true;
        state.isAddItemLine = false;
      })
      .addCase(deleteErpSalesOrderItems.rejected, handleRejection)

      .addCase(fetchOrderlineItem.pending, handlePending)
      .addCase(fetchOrderlineItem.fulfilled, (state, action) => {
        state.loading = false;
        state.orderlineNumber = action?.payload || 0;
      })
      .addCase(fetchOrderlineItem.rejected, (state, action) => {
        handleRejection(state, action);
        state.orderlineNumber = state.startOrderLineNumber;
      });
  },
});

export const {
  setErpSearch,
  setErpManualOrder,
  resetValues,
  setManualPurchaseOrder,
  setErpStatingSearch,
  setErpFastSearch,
  setErpFastSearchItems,
  setDisplayType,
  setSelectedOrder,
  setEntitlementSummary,
  setRowsPerPage,
  handleAddItemModal,
  handleProductModal,
  handleResetSearch,
  handleProductSearchForm,
  selectedProductData,
  clearSelectedProductData,
  handleErpLineItemForm,
  handleSlelcetederpLineItem,
  handleUpdateErpItemsdata,
  handleErpLinePriceForm,
  handleSaveApiResponse,
  handleErrorAlert,
  handleProductNameSearchFound,
  handleIsDisabled,
  setBackUrl,
  handleisErpLineUpdate,
  resetMultipleInputs,
  setdoNotResetFlag,
  setShipDate,
  setAddLineItemClicked,
  setCreatedMPOSuccessfully,
  resetOrderItems,
} = ErpSalesOrderSlice.actions;
export default ErpSalesOrderSlice.reducer;
